import React, { useState, useEffect } from "react";
import { TrashIcon } from "@heroicons/react/24/solid";
import { ChevronUpIcon, ChevronDownIcon } from "@heroicons/react/24/solid";

const ScoreBoxForReOrderPara = ({ practiceItemId, onIsAttempted }) => {
  const [responses, setResponses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const fetchResponses = async () => {
      try {
        const response = await fetch(
          `/api/get-user-responses/${practiceItemId}`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch responses");
        }
        const responseData = await response.json();
        setResponses(responseData);
        setLoading(false);
        if (responseData.length > 0) {
          onIsAttempted(responseData[0].isAttempted);
        }
      } catch (error) {
        console.error("Error fetching responses:", error);
        setLoading(false);
      }
    };

    if (practiceItemId) {
      fetchResponses();
    }
  }, [practiceItemId, onIsAttempted]);

  const toggleBox = () => {
    setIsOpen(!isOpen);
  };

  const deleteResponse = async (id) => {
    try {
      await fetch(`/api/delete-response/${id}`, { method: "DELETE" });
      const updatedResponses = responses.filter(
        (response) => response.id !== id
      );
      setResponses(updatedResponses);
    } catch (error) {
      console.error("Error deleting response:", error);
    }
  };

  const checkPairs = (orderResponses) => {
    if (!orderResponses || orderResponses.length === 0) {
      return [];
    }

    const pairs = orderResponses.map((item, index) => {
      if (index < orderResponses.length - 1) {
        const currentIndex = item.index;
        const nextIndex = orderResponses[index + 1].index;
        return { ...item, isCorrect: nextIndex === currentIndex + 1 };
      }
      return { ...item, isCorrect: false };
    });

    return pairs;
  };

  return (
    <div className="p-4 m-4 border rounded-lg shadow-lg bg-white">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-bold">Your Responses</h2>
        <button
          onClick={toggleBox}
          className="flex items-center text-gray-500 focus:outline-none"
        >
          {isOpen ? (
            <ChevronUpIcon className="h-5 w-5" />
          ) : (
            <ChevronDownIcon className="h-5 w-5" />
          )}
        </button>
      </div>

      {isOpen && (
        <div>
          {loading ? (
            <p>Loading...</p>
          ) : (
            responses.map((response, index) => {
              if (!response.orderResponses) {
                console.warn("Response is missing orderResponses:", response);
                return null;
              }

              const orderResponses = checkPairs(response.orderResponses);

              return (
                <div
                  key={response.id}
                  className={`mb-6 ${
                    index !== responses.length - 1
                      ? "pb-6 border-b border-gray-300"
                      : ""
                  }`}
                >
                  <div className="flex flex-col md:flex-row items-start md:items-center mb-2">
                    <p className="font-bold mr-2">{index + 1}.</p>
                    <div className="flex-grow w-full ">
                    <div className="overflow-x-auto">
                    <table className="min-w-full divide-y divide-gray-200 border border-gray-300 rounded-lg mb-4 text-xs md:text-sm">
                        <thead className="bg-gray-50">
                          <tr>
                            <th className="px-2 md:px-6 py-2 text-left font-medium text-gray-500 uppercase">Date/Time</th>
                            <th className="px-2 md:px-6 py-2 text-left font-medium text-gray-500 uppercase">Correct Options</th>
                            <th className="px-2 md:px-6 py-2 text-left font-medium text-gray-500 uppercase">Incorrect Options</th>
                            <th className="px-2 md:px-6 py-2 text-left font-medium text-gray-500 uppercase">Total Score</th>
                            <th className="px-2 md:px-6 py-2 text-left font-medium text-gray-500 uppercase">Remarks</th>
                            <th className="relative px-2 md:px-6 py-2"></th>
                          </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200">
                          <tr>
                            <td className="px-2 md:px-6 py-2 text-gray-500">{new Date(response.updatedAt).toLocaleDateString("en-GB")}</td>
                            <td className="px-2 md:px-6 py-2 text-gray-500">{response.userCorrectOptionNumber}</td>
                            <td className="px-2 md:px-6 py-2 text-gray-500">{response.userIncorrectOptionNumber}</td>
                            <td className="px-2 md:px-6 py-2 text-gray-500">{response.totalScore}</td>
                            <td className="px-2 md:px-6 py-2 text-gray-500">{Array.isArray(response.remarks) ? response.remarks.join(", ") : response.remarks}</td>
                            <td className="px-2 md:px-6 py-2 text-right">
                              <TrashIcon className="h-5 w-5 text-gray-500 cursor-pointer hover:text-red-600" onClick={() => deleteResponse(response.id)} />
                            </td>
                          </tr>
                        </tbody>
                      </table>
</div>
                     

                      <div className="border border-gray-300 rounded-lg p-2 md:p-4">
                        <p className="font-bold">User Response:</p>
                        <div className="flex flex-wrap mt-2">
                          {orderResponses.map((item, idx) => (
                            <div
                              key={idx}
                              className={`px-1 rounded-md mr-1 mb-1 text-xs md:text-sm ${
                                item.isCorrect ? "bg-green-300" : "bg-red-400"
                              }`}
                            >
                              {item.sentence}
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })
          )}
        </div>
      )}
    </div>
  );
};

export default ScoreBoxForReOrderPara;
